import getUndef from "./get-undef";
import getFromWindow from "./get-from-window";
import { getCheckout_checkout_lineItems } from "../__generated__/getCheckout";

declare global {
  interface Window {
    dataLayerYA: any;
  }
}

type Product = {
  id: string;
  name: string;
  price: number;
  category: string;
  quantity: number;
};

export const ecommerceAddToBasket = ({
  id,
  name,
  price,
  category,
  quantity,
}: Product) =>
  getFromWindow(() =>
    window.dataLayerYA.push({
      ecommerce: {
        add: {
          products: [
            {
              id,
              name,
              price,
              category,
              quantity,
            },
          ],
        },
      },
    })
  );

export const ecommerceRemoveFromBasket = ({
  id,
  name,
  category,
  quantity,
}: Partial<Product>) =>
  getFromWindow(() =>
    window.dataLayerYA.push({
      ecommerce: {
        remove: {
          products: [
            {
              id,
              name,
              category,
              quantity,
            },
          ],
        },
      },
    })
  );

export const ecommerceBuy = ({
  actionFieldId,
  lineItems,
}: {
  actionFieldId: string;
  lineItems: getCheckout_checkout_lineItems[];
}) => {
  const products: Product[] = lineItems.map(({ variant, quantity }) => {
    const { id, name, price, product } = variant;
    const category = getUndef(() => product.collections[0].slug) || "";

    return {
      id,
      name,
      price,
      category,
      quantity,
    };
  });

  getFromWindow(() =>
    window.dataLayer.push({
      ecommerce: {
        purchase: {
          actionField: {
            id: actionFieldId,
          },
          products,
        },
      },
    })
  );
};
